import { tv } from "tailwind-variants";
const styles = tv({
  base: "box-border shrink-0 font-semibold text-2xs flex justify-center items-center uppercase",
  variants: {
    color: {
      primary: "bg-peach",
      white: "bg-white text-black border-2 border-grey-2",
      grey: "text-white bg-grey-10 border-2 border-grey-8",
    },
    variant: {
      square: "px-2 rounded-2 h-6",
      round: "size-6 rounded-full",
    },
  },
});

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  color?: "primary" | "grey" | "white";
  variant?: "square" | "round";
}

export default function Badge({
  children,
  color = "primary",
  variant = "square",
  className,
  style,
}: Props) {
  return (
    <div className={styles({ color, variant, className })} style={style}>{children}</div>
  );
}
